// eslint-disable-next-line import/no-unresolved

import Router from 'src/routes/sections';

import 'src/locales/i18n';
import {AuthProvider} from 'src/auth/context/amplify';

import EnvBanner from 'src/components/env-banner';
import ProgressBar from 'src/components/progress-bar';

import ThemeProvider from "./theme/index";
import ReloadPrompt from "./sections/ReloadPrompt";
import NativeBridge from "./sections/NativeBridge";
import {LocalizationProvider} from "./locales/index";
import {useScrollToTop} from "./hooks/use-scroll-to-top";
import {MotionLazy} from "./components/animate/motion-lazy";
import {SettingsProvider} from "./components/settings/index";
import SnackbarProvider from "./components/snackbar/snackbar-provider";

export const App = () => {

  // const intervalMS = import.meta.env.VITE_ENV === "local" ? 60 * 1000 : 60 * 60 * 1000;

  // const updateServiceWorker =
  // useRegisterSW({
  //   onRegistered(r) {
  //     if (r) {
  //       console.log(r);
  //       setInterval(() => {
  //         console.log('Service Worker updated');
  //         r.update()
  //       }, intervalMS)
  //     }
  //   }
  // })

  useScrollToTop();

  return <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark' | 'system'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ProgressBar/>
                <EnvBanner/>
                <Router/>
                <NativeBridge/>
                <ReloadPrompt/>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
}
